import { CheckCircle2, DoorOpen, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Pantalla de "Cobro Exitoso" — presentacional. Toda la lógica vive en Terminal.jsx.
export const SuccessDialog = ({ successOpen, finalizarCobro, successMeta, paperWidth, setPaperWidth, imprimirComprobante }) => (
  <Dialog open={successOpen} onOpenChange={(o) => { if (!o) finalizarCobro(); }}>
    <DialogContent className="rounded-none border-[#10B981]/40 bg-[#0A0A0A] text-white sm:max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="success-dialog">
      <DialogHeader>
        <DialogTitle className="sr-only">Cobro exitoso</DialogTitle>
        <DialogDescription className="sr-only">Cobro realizado correctamente.</DialogDescription>
      </DialogHeader>
      <div className="py-6 flex flex-col items-center text-center gap-5">
        <CheckCircle2 className="h-20 w-20 text-[#34D399]" strokeWidth={1.5} />
        <div>
          <p className="font-display text-3xl font-black tracking-tight text-[#34D399]" data-testid="success-title">¡Cobro Exitoso!</p>
          <p className="text-sm text-white/60 mt-1">
            {successMeta.metodo}{successMeta.folio_aut ? <> · Aut. MP <span className="font-mono text-white">{successMeta.folio_aut}</span></> : null}
          </p>
          <p className="font-display text-4xl font-black text-[#FFCC00] mt-2" data-testid="success-total">${Number(successMeta.total || 0).toFixed(2)}</p>
        </div>
        <div className="w-full space-y-3">
          <button autoFocus onClick={finalizarCobro} data-testid="success-cerrar-btn"
            className="btn-hard w-full h-16 bg-[#10B981] text-white border border-[#10B981] font-black uppercase tracking-wider text-lg flex items-center justify-center gap-2 focus:ring-2 focus:ring-white focus:outline-none">
            <DoorOpen className="h-6 w-6" /> Cerrar / Nuevo Cobro
          </button>
          <div className="flex items-center gap-2" data-testid="success-print-group">
            <div className="flex items-center border border-white/15">
              <button onClick={() => setPaperWidth(58)} data-testid="paper-58-btn"
                className={`h-11 px-3 text-xs font-bold uppercase tracking-wider transition-colors duration-200 ${paperWidth === 58 ? "bg-[#FFCC00] text-[#0A0A0A]" : "text-white/50 hover:text-white"}`}>58mm</button>
              <button onClick={() => setPaperWidth(80)} data-testid="paper-80-btn"
                className={`h-11 px-3 text-xs font-bold uppercase tracking-wider transition-colors duration-200 ${paperWidth === 80 ? "bg-[#FFCC00] text-[#0A0A0A]" : "text-white/50 hover:text-white"}`}>80mm</button>
            </div>
            <button onClick={() => imprimirComprobante(paperWidth)} data-testid="success-imprimir-btn"
              className="flex-1 h-11 inline-flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wider text-white/60 hover:text-white border border-white/15 hover:border-white/40 transition-colors duration-200">
              <Printer className="h-4 w-4" /> Imprimir Comprobante
            </button>
          </div>
          <p className="text-[11px] text-white/40">La impresión es opcional · Enter para cerrar y seguir</p>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default SuccessDialog;
